module.exports = __webpack_public_path__ + "img/enticon.19ada6a2.png";